export const ROUTES = {
  HOME: '/',
  SURVEY: '/interview',
  SELECT_INTERVIEW: '/select-interview',
  PROJECT: '/project',
};

export const YES_NO_OPTIONS = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

export const FIRST_ELEMENT = 0;
export const SECOND_ELEMENT = 1;
export const ZERO = 0;
export const STEP = 1;
export const LAST_ELEMENT = -1;
export const HALF = 0.5;
export const TWO = 2;
export const FOUR = 4;
export const FIVE = 5;

export const EMPTY_STRING_PLACEHOLDER = '—';
export const DASH = '-';
export const EMPTY_STRING = '';
export const STRING_TRUNCATE_SIGN = '...';
export const IMPORT_EXPORT_FORMAT = '.XLSX';
export const IMPORT_EXPORT_PREFIX = 'pims';
export const CHECK_PLACEHOLDER = 'X';

export const MONTH_OFFSET = 1;
export const PAD_LENGTH = 2;
export const PAD_CHARACTER = '0';
export const PERCENTAGE_SIGN = '%';

export const GENERAL_QUESTIONS_ROWS = 2;

export const SORT_ASC = 1;
export const SORT_DESC = -1;

export const FORBIDDEN_STATUS_CODE = 403;
export const BAD_REQUEST_STATUS_CODE = 400;

export const DEFAULT_ICON_WIDTH = 20;
export const ACTION_ICON_WIDTH = 24;

export const MIN_YEAR = 1999;

export const DATA_FILTERS_OPTION_LENGTH = 12;

export const dialogDefaultState = {
  isOpen: false,
};

export const SUBMIT_TIMEOUT = 100;

export const HEXADECIMAL = 16;
export const HUNDRED = 100;

export const TEN = 10;
export const DEFAULT_OPACITY = 0.5;

export const DEFAULT_DEBOUNCE_DELAY = 500;
export const RESIZE_DEBOUNCE_DELAY = 300;

export const OPTIMAL_MULTIPLE = 5;

export const HEADER_LITERAL_REGEX = /^\0/;
export const DATA_SPLIT_SIGN = '|';
export const COMMA = ',';

export const PARTICIPANT_TOKEN_PARAM = 'url';
export const ID = 'id';

export enum CONFIRM_ACTION {
  SAVE = 'save',
  RESET = 'reset',
  TAB_CHANGE = 'tabChange',
}

export const PHONE_REGEX = /^(?:\+?[0-9]{1,3}(?:\s?[0-9]){7,10}|)$/;

export const validAndDirtyArgs = {
  shouldValidate: true,
  shouldDirty: true,
};

export const CVA_LINK = 'cva@pims.ai';

export const USER_GUIDE_LINK = 'https://docs.pims.ai/cva/doku.php?id=start';

export const USER_GUIDE_SIZE = {
  WIDTH: 1200,
  HEIGHT: 800,
};

export const COMMA_WITH_SPACE = ', ';
export const UNDERSCORE = '_';

export const SQUARE_BRACKETS_REGEXP = /[\\[\\]\s]/;

export const TBUS_NAME_KEY = 'THISBUS_NAME';

export const EMPTY_SPACE = ' ';
export const LINE_BREAK_TAG = '<br />';
